// Centralized link/message transformation for notifications
// Applied by data-layer hooks so UI never deals with raw messages

export const transformMessageLinks = (notifications, extraParams = {}) => {
  return (notifications || []).map((item) => {
    const courseId = item.objects?.course?.[0];
    const pageId = item.objects?.page?.[0];
    const user = item.objects?.user?.[0];
    const postId = item.objects?.post?.[0];
    const taskId = item.objects?.task?.[0];
    const type = item.type;

    const isLocalhost = typeof window !== 'undefined' &&
      (window.location?.hostname === 'localhost' || window.location?.hostname === '127.0.0.1');

    let transformedMessage = item.message;

    if (typeof transformedMessage !== 'string') {
      transformedMessage = String(transformedMessage ?? '');
    }

    if (transformedMessage.includes('/invitation/')) {
      if (isLocalhost) {
        transformedMessage = transformedMessage.replace(
          /(https?:\/\/)[^/]+(\/invitation\/[^"']+)/g,
          (_, __, path) => `http://localhost:3000${path}`
        );
      }
    }
    else if (type === 4 && courseId && (pageId || user) && taskId) {
      const newPath = `/view/course/${courseId}`;
      const queryParams = new URLSearchParams(extraParams).toString();
      const finalPath = queryParams ? `${newPath}?${queryParams}` : newPath;

      transformedMessage = transformedMessage.replace(
        /(https?:\/\/[^/]+)\/course\/[^"'\s]+/g,
        (_, baseUrl) => isLocalhost ? `http://localhost:3000${finalPath}` : `${baseUrl}${finalPath}`
      );
    }
    else if ((type === 8 || type === 3 || type === 9 || type === 12) && courseId && pageId) {
      const anchor = postId ? `#post-${postId}` : '';
      const newPath = `/view/course/${courseId}/${pageId}${anchor}`;
      const queryParams = new URLSearchParams(extraParams).toString();
      const finalPath = queryParams ? `${newPath}?${queryParams}` : newPath;

      transformedMessage = transformedMessage.replace(
        /(https?:\/\/[^/]+)\/course(s?)\/[^"']+/g,
        (_, baseUrl) => isLocalhost ? `http://localhost:3000${finalPath}` : `${baseUrl}${finalPath}`
      );
    }
    else if (type === 12 && courseId) {
      const newPath = `/view/course/${courseId}`;

      transformedMessage = transformedMessage.replace(
        /(https?:\/\/[^/]+)\/course(s?)\/[^"']+/g,
        (_, baseUrl) => isLocalhost ? `http://localhost:3000${newPath}` : `${baseUrl}${newPath}`
      );
    }

    return {
      ...item,
      message: transformedMessage,
    };
  });
};

export default transformMessageLinks;

